module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.fea9406.woff";